import type { RouteRecordRaw } from 'vue-router';

export const cPOLITICA_PRIVACIDADE_ROUTES = {
  Privacidade: {
    name: 'PoliticaPrivacidade',
    path: '/privacidade',
    component: () => import('@/modules/policies/PoliticaPrivacidade.vue'),
  },
};

export const rotasPoliticaPrivacidade: Array<RouteRecordRaw> = [
  {
    path: cPOLITICA_PRIVACIDADE_ROUTES.Privacidade.path,
    name: cPOLITICA_PRIVACIDADE_ROUTES.Privacidade.name,
    component: cPOLITICA_PRIVACIDADE_ROUTES.Privacidade.component,
    meta: { requiresAuth: false },
  },
];
